/**
 * A mapping from app_ref query parameters to an X-YouVersion-Client name.
 * The Client name is sent with the /confirm API call and is used for tracking numbers of users creating accounts
 * for certain applications.
 */
const APP_REF_TO_CLIENT_HEADER = {
  'bible.com': 'youversion',
  'youversion-connect': 'portal',
} as const;

/** Recognized app_ref query parameters. */
export type AppRefQueryParam = keyof typeof APP_REF_TO_CLIENT_HEADER;

/**
 * Given an app_ref from a QueryParam, returns the associated X-YouVersion-Client name.
 * @param appRef - The app_ref from a QueryParam.
 *
 * @example
 * ```ts
 *      const app_ref = 'bible.com';
 *      // Returns `youversion`
 *      const yvClientHeader = getClientHeaderFromAppRef(app_ref)
 *      const headers: Record<string, string> = {
 *        accept: 'application/json',
 *        'Content-Type': 'application/json',
 *        'X-YouVersion-App-Platform': 'web',
 *        'X-YouVersion-App-Version': APP_VERSION,
 *        'X-YouVersion-Client': yvClientHeader ?? 'portal',
 *      };
 * ```
 */
export function getClientHeaderFromAppRef<T extends AppRefQueryParam>(appRef: T): (typeof APP_REF_TO_CLIENT_HEADER)[T] {
  return APP_REF_TO_CLIENT_HEADER[appRef];
}
